import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getAppNoteAvailableColumns, getRealEstatesShort } from './api';

export const path = '/app/note/list';

const PageAppNote: React.FC = (props) => {
  const AppNote = Loadable.Map({
    loader: {
      page: () => import('./page'),
      realEstates: getRealEstatesShort,
      columns: getAppNoteAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <AppNote {...props} />;
};

export default PageAppNote;
